import { render, staticRenderFns } from "./queryFlux.vue?vue&type=template&id=56a612de&"
import script from "./queryFlux.vue?vue&type=script&lang=js&"
export * from "./queryFlux.vue?vue&type=script&lang=js&"
import style0 from "./queryFlux.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports